import React, { useState } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Circle,
  color,
  Divider,
  Flex,
  Heading,
  IconButton,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Select,
  Square,
  Text,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  filterActions,
  studentActions,
} from "../../../redux/actions";
import AjnaVidyaLogo from "../../../Assets/Ajnavidyalogo.svg";
import AjnaVidyaLogo2 from "../../../Assets/AjnaVidyaLogoNew2.png";
import hamIcon from "../../../Assets/hamIcon.png";
import search from "../../../Assets/search.png";
import plus from "../../../Assets/plus_icon.png";
import bell from "../../../Assets/bell_icon.png";
import chat from "../../../Assets/message2.svg";
import password from "../../../Assets/password.svg";
import logout from "../../../Assets/newLogout.svg";
import company from "../../../Assets/company.png";
import DefaultIcon from "../../../Assets/DefaultIcon.svg";
import { CloseIcon } from "@chakra-ui/icons";
import { recruiterActions } from "../../../redux/actions";
import Navlinks from "Components/Students/Navlinks/Navlinks";
import Popup from "Components/Students/popover";
import { notification } from "socket";
import { NotificationPopup } from "Components/Students/popover/NotificationPopup";
import tc from "../../../Assets/tc.svg";

const Navbar = () => {
  const [display, setChangeDisplay] = useState("none");
  const [stateActive, setStateActive] = useState(false);
  const [stateClosed, setStateClosed] = useState(false);
  const [newMessage, setNewMessage] = useState(0);
  const [notificationMessage, setNotificationMessage] = useState([]);
  const [stateDraft, setStateDraft] = useState(false);
  const [stateTalent, setStateTalent] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const recruiter = useSelector((state) => state.recruiter?.data);
  console.log(recruiter);
  const [user, setUser] = useState("");

  const levels = [
    "Foundation",
    "3D NFT Creator",
    "3D Environment Creator",
    "XR Interaction Creator",
    "Simulation Creator",
    "Ajna Creator",
  ];
  // const handleActive = () => {
  //   stateActive(true);
  //   stateClosed(false);
  //   stateDraft(false);
  // };
  const location = useLocation();
  useEffect(() => {
    if (location) {
      setStateActive(false);
      setStateClosed(false);
      setStateDraft(false);
      const locationEndpoint = location && location.pathname.split("/");
      if (locationEndpoint[3] === "active") {
        setStateActive(true);
      } else if (locationEndpoint[3] === "closed") {
        setStateClosed(true);
      } else if (locationEndpoint[3] === "draft") {
        setStateDraft(true);
      } else if (locationEndpoint[3] === "findtalent") {
        setStateTalent(true);
      }
    }
    const locationEndpoint = location.pathname.split("/");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?._id;
    if (locationEndpoint[2] === "recruiter" || user?.profile === "recruiter") {
      dispatch(recruiterActions.setRecruiter(userId));
      setUser("recruiter");
    }
  }, [location]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filters.filter);
  const handlePost = () => {
    navigate("/hiring/recruiter/createPost");
  };
  const searchHandler = async () => {
    navigate("/hiring/recruiter/search");
  };

  const bold = (text) => {
    return <style fontWeight={800}>{text}</style>;
  };

  useEffect(() => {
    if (filters) {
      dispatch(studentActions.setStudents(`badge${filters}`));
    }
  }, [filters]);

  const room = JSON.parse(localStorage.getItem("user"))?._id;
  const name = JSON.parse(localStorage.getItem("user"))?.name;
  useEffect(() => {
    notification.emit("login", { room, name }, (err) => {
      if (err) {
        return;
      } else {
      }
    });
    notification.on("response", (data) => {
      setNotificationMessage(data);
    });
  }, [notification]);

  useEffect(() => {
    notification.on("historical_messages", function (messages) {
      if (messages[0]?.room === room) {
        const sortByTimeStamps = (a, b) => {
          return new Date(b.timestamp) - new Date(a.timestamp);
        };
        setNotificationMessage(
          messages.sort(sortByTimeStamps).map((message) => {
            return {
              ...message,
              message: message.text,
            };
          })
        );
      }
    });
    notification.on("message", function (data) {
      if (data.room === room) {
        setNotificationMessage((prev) => [
          {
            ...data,
            message: data.text,
          },
          ...prev,
        ]);
        setNewMessage((prev) => prev + 1);
      }
    });
  }, [notification]);

  // console.log(recruiter);
  return (
    <div>
      <Box>
        {/* Container */}
        <Box
          borderBottom="1px solid #DEDEDE"
          // boxShadow={"0px 4px 18px rgba(0, 0, 0, 0.13)"}
          w="100%"
          display={["none", "none", "none", "flex", "flex"]}
          px={[0, 0, 0, 0, 1]}
          bg={"#fff"}
          position={"fixed"}
          zIndex={+1000}
          top={0}
        >
          <Box w="100%">
            {/* Main Flex */}
            <Center>
              <Flex
                align="center"
                h="100%"
                justify={"space-between"}
                css={{
                  "@media screen and (min-width: 1541px) and (max-width:1980px)":
                    {
                      width: "100%",
                      paddingLeft: 40,
                      paddingRight: 40,
                    },
                  "@media screen and (min-width: 1441px) and (max-width:1540px)":
                    {
                      width: "100%",
                      paddingLeft: 40,
                      paddingRight: 40,
                    },
                  "@media screen and (min-width: 1240px) and (max-width:1440px)":
                    {
                      width: "100%",
                      paddingLeft: 20,
                      paddingRight: 20,
                    },
                }}
              >
                {/* First Half */}
                <Box>
                  <Flex align="center" gap={[12, 12, 12, 12, 6, 20, 20]}>
                    {/* Logo */}
                    <Link to={"/hiring/recruiter/findtalent"} replace={true}>
                      <Box>
                        <Flex align="center" gap={2}>
                          <Box>
                            <img
                              style={{ height: "40px", width: "150px" }}
                              src={AjnaVidyaLogo}
                              alt="logo"
                            />
                          </Box>
                        </Flex>
                      </Box>
                    </Link>
                    {/* Tabs */}
                    <Box>
                      <Flex gap={35}>
                        <Link to={"/hiring/recruiter/active"} replace={true}>
                          <Box
                            cursor="pointer"
                            w={100}
                            h="auto"
                            py={7}
                            pb={7}
                            borderBottom={
                              stateActive
                                ? "2px solid #6C56FB"
                                : "2px solid transparent"
                            }
                            color={stateActive ? "#6C56FB" : "#85808C"}
                          >
                            <Heading
                              fontSize={[16, 16, 16, 16, 16, 20, 20]}
                              fontWeight={stateActive ? "500" : "400"}
                              fontFamily={"Roboto"}
                              letterSpacing={"0.04em"}
                            >
                              Active
                            </Heading>
                          </Box>
                        </Link>
                        <Link to="/hiring/recruiter/closed" replace={true}>
                          <Box
                            cursor="pointer"
                            w={100}
                            h="auto"
                            py={7}
                            pb={7}
                            borderBottom={
                              stateClosed
                                ? "2px solid #6C56FB"
                                : "2px solid transparent"
                            }
                            color={stateClosed ? "#6C56FB" : "#85808C"}
                          >
                            <Heading
                              fontSize={[16, 16, 16, 16, 16, 20, 20]}
                              fontWeight={stateClosed ? "500" : "400"}
                              fontFamily={"Roboto"}
                              letterSpacing={"0.04em"}
                            >
                              Closed
                            </Heading>
                          </Box>
                        </Link>
                        <Link to="/hiring/recruiter/draft">
                          <Box
                            cursor="pointer"
                            w={100}
                            h="auto"
                            py={7}
                            pb={7}
                            borderBottom={
                              stateDraft
                                ? "2px solid #6C56FB"
                                : "2px solid transparent"
                            }
                            color={stateDraft ? "#6C56FB" : "#85808C"}
                          >
                            <Heading
                              fontSize={[16, 16, 16, 16, 16, 20, 20]}
                              fontWeight={stateDraft ? "500" : "400"}
                              fontFamily={"Roboto"}
                              letterSpacing={"0.04em"}
                            >
                              Draft
                            </Heading>
                          </Box>
                        </Link>
                        <Link to="/hiring/recruiter/findtalent">
                          <Box
                            cursor="pointer"
                            w={140}
                            h="auto"
                            py={7}
                            pb={7}
                            px={4}
                            borderBottom={
                              stateTalent
                                ? "2px solid #6C56FB"
                                : "2px solid transparent"
                            }
                            color={stateTalent ? "#6C56FB" : "#85808C"}
                          >
                            <Heading
                              fontSize={[16, 16, 16, 16, 16, 20, 20]}
                              fontWeight={stateTalent ? "500" : "400"}
                              fontFamily={"Roboto"}
                              letterSpacing={"0.04em"}
                              w={"fit-content"}
                            >
                              Find Talent
                            </Heading>
                          </Box>
                        </Link>
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
                {/* Second Half */}
                <Box>
                  <Flex align="center" gap={5}>
                    {/* thease box will be removed after adding chat and message icon */}
                    <Box></Box>
                    {/* Post Job Button */}
                    <Box onClick={handlePost} cursor="pointer">
                      <Flex
                        align="center"
                        w={200}
                        justify="center"
                        h={43}
                        borderRadius={12}
                        gap={2}
                        bg="#6C56FB"
                        _hover={{
                          boxShadow: "0px 8px 24px rgba(108, 86, 251, 0.2)",
                        }}
                        transition="0.2s"
                      >
                        <Box textAlign="center">
                          <img src={plus} alt="plus" />
                        </Box>

                        <Text
                          color="#FFFFFF"
                          fontSize={[16, 16, 16, 16, 16, 18, 18]}
                          fontWeight={500}
                          fontFamily={"Roboto"}
                          letterSpacing={"0.04em"}
                        >
                          Post New Job
                        </Text>
                      </Flex>
                    </Box>
                    {/* notification Icon */}

                    <Circle
                      size={42}
                      border="1px solid #DDDDDD"
                      cursor={"pointer"}
                      onClick={() => {
                        setNewMessage(0);
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        {newMessage > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "-15px",
                              left: "10px",
                              fontSize: "12px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "white",
                              backgroundColor: "#6C56FB",
                              width: "20px",
                              borderRadius: "50%",
                              height: "20px",
                            }}
                          >
                            {newMessage > 0 && newMessage}
                          </div>
                        )}
                        <NotificationPopup
                          notificationMessage={notificationMessage}
                          setNewMessage={setNewMessage}
                        />
                      </div>
                    </Circle>

                    {/* Chat Icon */}
                    <Link to="/hiring/recruiter/chat">
                      <Circle size={42} border="1px solid #DDDDDD">
                        <img src={chat} alt="chat" />
                      </Circle>
                    </Link>

                    {/* Profile Icon */}
                    <Popover>
                      <PopoverTrigger>
                        <Circle
                          size={42}
                          border="1px solid #DDDDDD"
                          cursor="pointer"
                          overflow={"hidden"}
                        >
                          <img
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                            }}
                            src={recruiter.profilePhoto || DefaultIcon}
                            alt="profile_icon"
                          />
                        </Circle>
                      </PopoverTrigger>
                      <PopoverContent zIndex={100} w={200} bg="#FFFFFF">
                        <PopoverArrow bg="#FFFFFF" />
                        <PopoverCloseButton />
                        <PopoverBody>
                          <Flex flexDirection="column" my={5} gap={2}>
                            {/* view profile */}
                            <Flex
                              align="center"
                              gap={2}
                              cursor="pointer"
                              onClick={() => {
                                navigate("/hiring/recruiter/profile");
                              }}
                            >
                              <Circle
                                size={7}
                                border="1px solid #D9D9D9"
                                overflow={"hidden"}
                              >
                                <img
                                  style={{ height: "100%", width: "100%" }}
                                  src={recruiter.profilePhoto || DefaultIcon}
                                  alt=""
                                />
                              </Circle>
                              <Box>
                                <Text fontSize={15} fontWeight={400}>
                                  {/* Route to respective page */}
                                  <Link to={"/hiring/recruiter/profile"}>
                                    View Profile
                                  </Link>
                                </Text>
                              </Box>
                            </Flex>
                            {/* T&c */}
                            <Flex
                              align="center"
                              gap={2}
                              cursor="pointer"
                              onClick={() => {
                                navigate("/hiring/recruiter/t&c");
                              }}
                            >
                              <Circle size={7} overflow={"hidden"}>
                                <img
                                  style={{ height: "100%", width: "100%" }}
                                  src={tc}
                                  alt=""
                                />
                              </Circle>
                              <Box>
                                <Text fontSize={15} fontWeight={400}>
                                  {/* Route to respective page */}
                                  <Link>Legal</Link>
                                </Text>
                              </Box>
                            </Flex>
                            <Divider border="1px solid #DEDEDE" />
                            {/* logout */}
                            <Flex align="center" gap={2} cursor="pointer">
                              <Circle size={7}>
                                <img
                                  height="80%"
                                  width="80%"
                                  src={logout}
                                  alt="logout"
                                />
                              </Circle>
                              <Box>
                                <Text
                                  fontSize={15}
                                  fontWeight={400}
                                  onClick={() => {
                                    dispatch(authActions.logout("recruiter"));
                                  }}
                                >
                                  <Link>Logout</Link>
                                </Text>
                              </Box>
                            </Flex>
                          </Flex>
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  </Flex>
                </Box>
              </Flex>
            </Center>
          </Box>
        </Box>

        {/* Mobile View */}

        <Flex
          display={["flex", "flex", "none", "none"]}
          justify="space-between"
          borderBottom={"1px solid #E4E4E4;"}
          py={2}
          w={"100%"}
          bg={"#fff"}
          position={"fixed"}
          top={0}
          zIndex={+1000}
        >
          <Flex align="center" gap={1}>
            <Circle size={10} onClick={() => setChangeDisplay("flex")}>
              <img src={hamIcon} alt="logo" />
            </Circle>
            <Circle
              size={8}
              style={{
                width: "175px",
              }}
            >
              <img src={AjnaVidyaLogo} alt="logo" height={"100%"} />
            </Circle>
          </Flex>

          {/* Create Job Post */}
          <Flex display={display === "flex" ? "flex" : "none"}>
            <Navlinks type={"recruiter"} setChangeDisplay={setChangeDisplay} />
          </Flex>
        </Flex>
      </Box>
    </div>
  );
};
export default Navbar;
